import { createAsyncThunk } from '@reduxjs/toolkit'
import { serializableError } from '@utils/serializable_error.ts'
import CustomizationWebAPI from '@api/CustomizationWebAPI.js'
import { handleSaveOptionsSuccess } from './ServerActions.js'
import { createLogger } from '@utils/logger.ts'

const log = createLogger('clientActions')
log.setLevel('info')

export const saveOptions = createAsyncThunk('resourceOptions/saveOptions', async (object, thunkAPI) => {
  log.debug('saveOptions called with object:', object)
  const { resourceId, resourceType, options } = object
  const { dispatch, rejectWithValue } = thunkAPI
  try {
    const response = await CustomizationWebAPI.saveCustomization(resourceType, resourceId, options)
    dispatch(handleSaveOptionsSuccess(response))
    // Note: Anything returned here becomes the payload of fulfilled action
  } catch (error) {
    return rejectWithValue(serializableError(error))
  }
})
